export const LabNames = {
  LABCORP: "Labcorp",
  QUEST: "Quest",
  KWIK_TRIP_CENTER_FOR_HEALTH: "KwikTrip",
  OSF_HEALTH_CARE: "OSF HealthCare",
  TASSO: "Tasso"
} as const;
